module.exports = __webpack_public_path__ + "static/media/上新.5ea3a648.png";